function ContactPage() {
    return (
        <div style={styles.page}>

            {/* HERO */}
            <section style={styles.hero}>
                <span style={styles.badge}>GET IN TOUCH</span>

                <h1 style={styles.title}>
                    Contact <span style={styles.gradientText}>Us</span>
                </h1>

                <p style={styles.subtitle}>
                    Feel free to contact us any time.
                </p>
            </section>

            {/* CONTACT CARDS */}
            <section style={styles.grid}>

                {/* PHONE */}
                <div style={styles.card}>
                    <h3 style={styles.cardTitle}>📞 Phone</h3>
                    <p style={styles.text}>+1 (270) 226-3331</p>
                    <p style={styles.text}>+1 (864) 768-5205</p>
                </div>

                {/* EMAIL */}
                <div style={styles.card}>
                    <h3 style={styles.cardTitle}>✉️ Email</h3>
                    <p style={styles.text}>contact@carolinasportsclub.com</p>
                </div>

                {/* ADDRESS */}
                <div style={styles.card}>
                    <h3 style={styles.cardTitle}>📍 Address</h3>
                    <p style={styles.text}>255 Service Bay Rd</p>
                    <p style={styles.text}>Mauldin, SC 29662</p>
                </div>

            </section>

            {/* MAP */}
            <section style={styles.mapSection}>
                <iframe
                    title="location"
                    src="https://www.google.com/maps?q=255+Service+Bay+Rd,+Mauldin,+SC+29662&output=embed"
                    style={styles.map}
                    loading="lazy"
                />
            </section>

        </div>
    );
}

const styles = {
    page: {
        width: "100%",
        boxSizing: "border-box",
        overflowX: "hidden",
        padding: "20px",
        color: "#fff",
    },

    hero: {
        textAlign: "center",
        padding: "15px 15px",
    },

    badge: {
        display: "inline-block",
        padding: "6px 14px",
        borderRadius: "20px",
        background: "rgba(0,255,150,0.1)",
        border: "1px solid rgba(0,255,150,0.3)",
        color: "#00f5a0",
        fontSize: "12px",
        marginBottom: "10px",
    },

    title: {
        fontSize: "42px",
        marginBottom: "10px",
    },

    gradientText: {
        background: "linear-gradient(90deg, #00f5a0, #00d9f5)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },

    subtitle: {
        color: "#d1d5db",
    },

    grid: {
        display: "flex",
        justifyContent: "center",
        gap: "20px",
        flexWrap: "wrap",
        marginTop: "20px",
    },

    card: {
        width: "260px",
        padding: "20px",
        borderRadius: "16px",
        background: "rgba(0,40,70,0.6)",
        border: "1px solid rgba(0,255,150,0.2)",
    },

    cardTitle: {
        marginBottom: "10px",
        fontSize: "18px",
    },

    text: {
        color: "#d1d5db",
        fontSize: "14px",
    },

    mapSection: {
        marginTop: "30px",
        display: "flex",
        justifyContent: "center",
    },

    map: {
        width: "90%",
        maxWidth: "900px",
        height: "350px",
        border: "0",
        borderRadius: "16px",
    },
};

export default ContactPage;